/*globals $, Social, User, observeDOM */

$(document).ready(function() {
    "use strict";

    $('[data-toggle="popover"]').popover({ trigger: "hover" });

    if ($("#prodContainerDate").length > 0) {
        $("#prodContainerDate").datepicker();
    }

    if ($(".store-results-init").length > 0) {
        MAPBASE.updateMapSize($("#GMLocator"));
    }

    checkMobile();

    // Custom checkboxes
    $.each($('input[type="checkbox"]'), function () {
        if ($(this).is(":checked")) {
            $(this)
                .parent()
                .addClass("checked");
        }
    });

    $('input[type="checkbox"]').on("change", function (e) {
        if ($(this).is(":checked")) {
            $(this)
                .parent()
                .addClass("checked");
        } else {
            $(this)
                .parent()
                .removeClass("checked");
        }
    });

    // Offer button
    $("[data-offer-click]").on("click", function (e) {
        var offerId = $(e.target).data("offer-click");

        $.ajax({
            url: ajaxurl,
            method: "post",
            dataType: "html",
            data: {
                action: "coupon_interaction",
                offerid: offerId
            },
            success: function(result) {
                //console.log(result);
            }
        });
    });

    // Print button
    $("[data-print-btn]").on("click", function (e) {
        var printNode = $(e.target).data("print-btn"),
            offerId = $(e.target).data("offer-click"),
            printCoupon = printNode + "-" + offerId;

        e.preventDefault();

        switch (printCoupon) {
        case ".contest-offer":
            sendGAEvent($(e.target), "Print Coupon", "BFF Contest Offers");
            break;
        default:
            $(".exclusive-offer").removeClass("print-this");
            $(printCoupon).addClass("print-this");
            sendGAEvent($(e.target), "Print Coupon", "BFF Exclusive Offers");
            break;
        }
        window.print();
    });

    // Homepage CTAs
    $("#homepageHero .ctas .btn").on("click", function (e) {
        var gaEvent = $(this).data("ga-event");

        if (gaEvent && gaEvent !== "") {
            sendGAEvent($(this), gaEvent, "Homepage CTAs");
        }
    });

    // Get Giftcard button
    $("[data-giftcard-link]").on("click", function (e) {
        sendGAEvent($(e.target), "Buy Gift Cards", "Gift Cards");
    });

    $("#headerMenu").on("show.bs.collapse", function () {
        $(this)
            .parent()
            .addClass("nav-open");
    });

    $("#headerMenu").on("hidden.bs.collapse", function () {
        $(this)
            .parent()
            .removeClass("nav-open");
        $("#pageSearchBar").val("").trigger('change');
    });

    $("#searchForm").on("show.bs.dropdown", function () {
        $(".nav-item-5").addClass("search-open");
    });

    $("#searchForm").on("hide.bs.dropdown", function () {
        $(".nav-item-5").removeClass("search-open");
    });

    // Forms
    $("[data-form]").on("submit", function (e) {
        e.preventDefault();
        sendFormData($(e.target));
    });

    document.addEventListener("gml_after_search_results", function (e) {
        var fullHeight = $("#GMLocator").height(),
        offsetHeight = 0;

        $.each(
            $("#GMLocator")
                .find(".search-holder")
                .children(),
                function() {
                    if (!$(this).hasClass("search-results") && $(this).is(":visible")) {
                        offsetHeight += $(this).outerHeight();
                    }
                }
        );
        offsetHeight += $("#locateSearch").height();

        if (!isMobile()) {
            $("#GMLocator")
                .find(".results-content")
                .css("height", fullHeight - offsetHeight);
        }
    });

    // share button popup
    $("body").on("click", ".shareBtn", function (e) {
        e.preventDefault();

        if ($(this).attr("data-ga-event")) {
            sendGAEvent($(this), $(this).text(), "Share");
        }

        window.open(
            $(this).attr("href"),
            "shareWindow",
            "height=450, width=550, top=" +
                ($(window).height() / 2 - 275) +
                ", left=" +
                ($(window).width() / 2 - 225) +
                ", toolbar=0, location=0, menubar=0, directories=0, scrollbars=0"
        );
        return false;
    });

    $(".matchHeight").matchHeight();

    // Kid Friendly
    $("#kidFriendlyCTASticky").sticky();
});

$(window).resize(function() {
    "use strict";

    checkMobile();
    // positionSliderNav();
});